import React from 'react';

// Routes
import Routes from './leads-all-routes';

export default function (props) {

  return (
   <div>
       <Routes />
   </div>
  )
}
